export default "__VITE_ASSET__BbWJQKEj__"